import { Tooltip } from '@mui/material';
import dayjs from 'dayjs';
import React from 'react';

import { styled } from 'core/styles';

import { NoSSR } from '../NoSSR';

export function DateLabel({ date }: { date: Date }) {
  return (
    <Tooltip
      title={dayjs(date).format('YYYY-MM-DD hh:mm:ss A')}
      disableFocusListener
      disableTouchListener
    >
      <Time dateTime={date.toISOString()}>
        <NoSSR>
          <>{dayjs(date).fromNow()}</>
        </NoSSR>
      </Time>
    </Tooltip>
  );
}

const Time = styled('time')(() => ({
  whiteSpace: 'nowrap',
}));
